// @ts-nocheck
import { HOME_FAQ as QA } from "@/data/homeFaq";

export default function FAQ() {
  return (
    <>
<section className="faq-sec">
  <div className="faq-inner">
    <div className="faq-side">
      <div className="ey rev">Questions</div>
      <h2 className="sh2 rev d1" style={{"fontSize":"clamp(24px,2.6vw,36px)"}}>Everything{" "}<br />you need{" "}<br />to know.</h2>
      <p className="faq-side-sub rev d2">Can&apos;t find an answer? <a href="/contact">Contact us</a> or reach us on WhatsApp.</p>
    </div>
    <div className="faq-list rev d1">
      {QA.map((item, i) => (
        <details key={i} className="fi">
          <summary className="fq">
            {item.q}
            <svg aria-hidden="true" className="fi-ico" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 16 16"><line x1="8" x2="8" y1="3" y2="13"/><line x1="3" x2="13" y1="8" y2="8"/></svg>
          </summary>
          <div className="fa"><div className="fa-inner">{item.a}</div></div>
        </details>
      ))}
    </div>
  </div>
</section>


    </>
  );
}
